/**
 * Lightweight logger wrapper for development and production
 * Replaces console.log with proper logging levels
 * @public
 */

interface Logger {
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
}

/**
 * Logger instance that only logs warnings in development and errors in all environments
 */
export const logger: Logger = {
  warn: (...args: unknown[]) => {
    if (import.meta.env.DEV) {
      console.warn('[WARN]', ...args);
    }
  },
  error: (...args: unknown[]) => {
    console.error('[ERROR]', ...args);
  },
};


